/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ContentItemPart from '../../components/ContentItemPart';
// import Tooltip from "@material-ui/core/Tooltip";
import { toast } from 'react-toastify';
import { Modal } from 'react-responsive-modal';
import UsePoint from '../point/UsePoint';
import moment from 'moment';
import { Base64 } from 'js-base64';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class ItemPart extends Component {
  state = {
    sort: 0,
    modalShow: false,
    allSelect: false,
    payGubun: 'down',
    param: '',
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getData(contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };
  _isTab = () => {
    const { userAgent, maxTouchPoints } = window.navigator;
    const isMac = /Macintosh/i.test(userAgent);
    if (isMac && maxTouchPoints > 0) return true;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi|mobi/i.test(
      userAgent
    );
  };

  _getData = async (contentSerial) => {
    const { onEpisodeCount } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi(contentSerial);
      const intReturn = result.data[0].intReturn;
      const contentPartList = result.data[0].listData;

      if (intReturn === 0) {
        onEpisodeCount(contentPartList.length);
        if (this._isMounted) {
          this.setState({
            contentPartList,
          });
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl, loginId, pkg } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)
    let userid;
    if (loginId === null || loginId === undefined || loginId === '') {
      userid = '';
    } else {
      userid = loginId;
    }
    return axios(
      apiUrl +
        '/itemPartNew?contentSerial=' +
        contentSerial +
        '&userid=' +
        userid +
        '&pkg=' +
        pkg
    )
      .then((response) => response)
      .catch((error) => {
        // alert('화별 데이터를 로드 중 오류가 발생했습니다.');
      });
  };
  _renderItem = () => {
    const { contentPartList } = this.state;

    const list = contentPartList.map((item, index) => {
      return (
        <ContentItemPart
          key={index}
          index={index}
          contentSerial={item.contentSerial}
          contentPartSerial={item.contentPartSerial}
          title={item.title}
          part={item.part}
          subTitle={item.subTitle}
          subPartSerial2={item.subPartSerial2}
          subPartSerial3={item.subPartSerial3}
          img={item.img}
          activeFlag={item.activeFlag}
          chkFree={item.chkFree}
          downActive={item.downActive}
          pos={item.pos}
          mediaTime={item.mediaTime}
          episode={item.contentEpisode}
          updateDate={item.updateDate}
          onCloseModal={this.props.childProps.onCloseModal}
          vodSupport={item.vodSupport}
          downSupport={item.downSupport}
          vodPrice={item.vodPrice}
          downPrice={item.downPrice}
          downExist={item.downExist}
          selected={item.selected}
          _selected={this._selected}
          fileName={item.fileName}
        />
      );
    });

    return list;
  };
  _toggleSort = (num) => {
    const { contentPartList } = this.state;

    if (num === 0) {
      contentPartList.sort(function (a, b) {
        return a.part > b.part ? -1 : a.part < b.part ? 1 : 0;
      });
    } else {
      contentPartList.sort(function (a, b) {
        return a.part < b.part ? -1 : a.part > b.part ? 1 : 0;
      });
    }

    //console.log(contentPartList)
    this.setState({
      sort: num,
      contentPartList,
    });
  };
  _onBuyDownload = () => {
    const { buyDownload } = this.props.childProps;
    buyDownload();
  };

  _onBuyVod = () => {
    const { buyVod } = this.props.childProps;
    buyVod();
  };
  _allSelect = () => {
    const { contentPartList, allSelect } = this.state;

    contentPartList.map((item, index) => {
      if (!allSelect) {
        item.selected = item.subPartSerial3;
        item.selected2 = item.subPartSerial2;
      } else {
        item.selected = 0;
        item.selected2 = 0;
      }
    });

    this.setState({
      allSelect: !allSelect,
    });
  };
  _selected = (index, subPartSerial3, subPartSerial2) => {
    const { contentPartList } = this.state;

    if (contentPartList[index].selected === 0) {
      contentPartList[index].selected = subPartSerial3;
      contentPartList[index].selected2 = subPartSerial2;
    } else {
      contentPartList[index].selected = 0;
      contentPartList[index].selected2 = 0;
    }

    this.setState({
      contentPartList: contentPartList,
    });
  };
  _selectedDown = async () => {
    const { loginId, aParam, authId, downloadBitrate, pkg } = this.props;
    const { contentPartList } = this.state;
    const { contentSerial } = this.props.childProps;

    //console.log(downCode)
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      //멤버십 체크.
      let downList = [];
      let param;

      contentPartList.find((item, index) => {
        if (item.selected !== 0) {
          downList.push(item.selected);
        }
      });

      if (downList.length <= 0) {
        toast.warn('다운받을 화수가 선택되지 않습니다.');
      } else {
        const result = await this._allDownCheckApi();
        if (result) {
          // const intReturn = result.data[0].intReturn;
          param = result.data[0].param;
          console.log('SelectDown: ' + param);
        }

        let stringCode = '';
        downList.map((item, index) => {
          stringCode = stringCode + item + ',';
        });

        const date = new Date();
        let timeStemp = moment(date).format('YYYYMMDDHHmmss');
        timeStemp = Base64.encode(timeStemp);

        // let ap = Base64.encode(aParam);

        const base64Data = await this._getBase64Encode(timeStemp);
        timeStemp = base64Data.data.codeString;
        const authUserid = aParam;
        const at = this.getCookie('at');
        // const at = localStorage.getItem('at');
        //console.log(authUserid, authId, stringCode)

        if (downloadBitrate === '1080P') {
          //console.log('https://www.aniplustv.com/download/down_test1.asp?userid=' + authUserid + '&chkSerial=' + subPartSerial3 + ',' + '&gubun=MP4&contentSerial=' + contentSerial + '&tk=' + timeStemp + '&ai=' + authId + '&ad=' )
          window.open(
            'https://www.aniplustv.com/download/down_n.asp?userid=' +
              authUserid +
              '&chkSerial=' +
              stringCode +
              ',' +
              '&gubun=MP4&contentSerial=' +
              contentSerial +
              '&tk=' +
              timeStemp +
              '&ai=' +
              authId +
              '&p=' +
              pkg +
              '&at=' +
              at +
              '&pm=' +
              param,
            'hiddenframe1',
            'width=0, height=0, left=0, height=0'
          );
        } else {
          //console.log('https://www.aniplustv.com/download/down720p.asp?userid=' + authUserid + '&chkSerial=' + subPartSerial3 + ',' + '&gubun=MP4&contentSerial=' + contentSerial)
          window.open(
            'https://www.aniplustv.com/download/down720p_n.asp?userid=' +
              authUserid +
              '&chkSerial=' +
              stringCode +
              ',' +
              '&gubun=MP4&contentSerial=' +
              contentSerial +
              '&tk=' +
              timeStemp +
              '&ai=' +
              authId +
              '&p=' +
              pkg +
              '&at=' +
              at +
              '&pm=' +
              param,
            'hiddenframe1',
            'width=0, height=0, left=0, height=0'
          );
        }
        /*
                this.setState({
                    modalShow: true,
                    stringCode
                })
                */
        //console.log(stringCode)
      }
    }
  };
  _allDownCheck = async () => {
    const { loginId } = this.props;
    const { contentPartList } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인후 이용해 주세요.');
    } else {
      if (isMobile) {
        alert(
          '모바일 웹에서는 다운로드를 지원하지 않습니다.\n\n전용앱을 이용해 주세요.'
        );
        return false;
      }

      const result = await this._allDownCheckApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        const param = result.data[0].param;
        console.log('allCheck: ' + param);
        //console.log(intReturn)
        if (intReturn === 0) {
          /*
                    let payList=[]
                    contentPartList.find((item, index) => {
                        if(item.selected !== 0) {
                            payList.push(item.selected2)
                        }
                    })
    
                    if(payList.length <= 0) {
                        
                    } else {
                        let downCode = ''
                        payList.map((item, index) => {
                            downCode = downCode + item + '|'
                        })
                    
                        this.setState({
                            downCode: downCode,
                        })
                    }
                    */
          setTimeout(() => {
            this._selectedDown();
          }, 700);
        } else if (intReturn === -1) {
          toast.error('정상적인 회원이 아닙니다.');
        } else if (intReturn === -2) {
          toast.error('19세 미만은 관람이 불가한 작품입니다.');
        } else if (intReturn === -3) {
          /*'멤버십 회원이 아님. 포인트 전환'*/

          let payList = [];
          contentPartList.find((item, index) => {
            if (item.selected !== 0) {
              payList.push(item.selected2);
            }
          });

          if (payList.length <= 0) {
            toast.warn('결제할 내역이 없습니다.');
          } else {
            let payCode = '';
            payList.map((item, index) => {
              payCode = payCode + item + ',';
            });
            //console.log(payCode)
            this.setState({
              payCode: payCode,
              modalShow: true,
            });

            //console.log(payCode)
          }
        } else if (intReturn === -4) {
          toast.error('서비스중인 콘텐츠가 아닙니다.');
        } else if (intReturn === -5) {
          toast.error('다운로드를 지원하지 않는 콘텐츠입니다.');
        }
      }
    }
  };
  _allDownCheckApi = () => {
    const { loginId, apiUrl, history } = this.props;
    const { contentSerial } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/downloadAllCheckNew',
        {
          params: {
            userid: loginId,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._allDownCheck();
      } else if (gubun === 1) {
        this._setPointUse();
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onCloseModal = () => {
    this.setState({
      modalShow: false,
    });
  };
  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;

        //console.log(intReturn)
        if (intReturn === 0) {
          this.setState({
            modalShow: false,
            payCode: '',
          });
          if (payGubun === 'down') {
            this._selectedDown();
            // this._allDownCheck();
          } else {
            //this._onPlay()
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _setPointUseApi = () => {
    const { payGubun, payCode } = this.state;
    const { contentSerial } = this.props.childProps;
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + payCode + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + subPartSerial2 + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=ppv' )
    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: payCode,
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: 'ppv',
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('포인트 정보를 로드중 오류가 발생했습니다.')
        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  render() {
    const { contentPartList, sort, allSelect, payCode, modalShow, payGubun } =
      this.state;
    const { contentSerial } = this.props.childProps;
    const { imgUrl, serviceEndDate } = this.props;

    const isTab = this._isTab();
    return (
      <Fragment>
        {/* 바 베너 위치
                
                <div className="pop_promotion_div1"><img src="/img/detail_img/baenr_img1.png"/></div>
                */}
        <div className="detil_group1 live_detail_epi">
          <h1>
            에피소드
            <span>
              {' '}
              {contentPartList ? '.총' + contentPartList.length + '화' : ''}
            </span>
            <div>
              <a
                className={sort === 0 ? 'on' : null}
                style={{ cursor: 'pointer' }}
                onClick={() => this._toggleSort(0)}
              >
                <span></span>최신화부터
              </a>
              <a
                className={sort === 1 ? 'on' : null}
                style={{ cursor: 'pointer' }}
                onClick={() => this._toggleSort(1)}
              >
                <span></span>첫화부터
              </a>
            </div>
          </h1>
          <div className="all_list_chek">
            {contentPartList ? (
              contentPartList[0].downSupport === 'Y' ? (
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : (
                  <div className="chek_all_group">
                    <input
                      type="checkbox"
                      className="chkBox"
                      name="chk"
                      id="chkAll"
                      checked={allSelect}
                      onChange={this._allSelect}
                    />
                    <label htmlFor="chkAll" className="chk"></label>전체선택
                  </div>
                )
              ) : null
            ) : null}

            <div>
              {isAndroid ||
              isIOS ||
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                serviceEndDate ? null : contentPartList ? (
                contentPartList[0].downSupport === 'Y' ? (
                  <button
                    type="button"
                    className="btn_epiTop"
                    onClick={this._allDownCheck}
                  >
                    <span>
                      <img src={imgUrl + '/img/live_img/ico_down.png'} /> 선택
                      다운받기
                    </span>
                  </button>
                ) : null
              ) : null}

              {contentPartList ? (
                contentPartList.length > 0 ? (
                  contentPartList[0].vodSupport === 'Y' ? (
                    moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate ? null : (
                      <button
                        type="button"
                        className="btn_epiTop"
                        onClick={this._onBuyVod}
                      >
                        <span>
                          <img src={imgUrl + '/img/live_img/ico_play.png'} />{' '}
                          스트리밍 전체 구매
                        </span>
                      </button>
                    )
                  ) : null
                ) : null
              ) : null}
            </div>
          </div>
          {/*
                    <div className="all_list_chek">
                       
                        <div className="chek_all_group">
                            <input name="선택" id="checkbox_1" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1">전체선택</label>
                        </div>
                        
                        <div>
                        {contentPartList ? contentPartList.length > 0 ? contentPartList[0].downSupport === 'Y' ? allDownPay ? (<a>구매완료</a>) : (<a style={{cursor: 'pointer'}} onClick={this._onBuyDownload}><div><span></span>전체 소장구매{contentGubun === 3 ? ('30%') : null}</div></a>) : null : null : null }
                        {contentPartList ? contentPartList.length > 0 ? contentPartList[0].vodSupport === 'Y' ? <a style={{cursor: 'pointer'}} onClick={this._onBuyVod}><Tooltip title="VOD 스트리밍 전체구매 하기"><div className="on"><span></span>스트리밍 전체 구매</div></Tooltip></a> : null : null : null }
                        </div>
                    </div>
                    */}
          <div className="episode_list_group">
            {contentPartList ? (
              this._renderItem()
            ) : (
              <div className="episode_list">
                <div className="episode_img"></div>
                <div className="chek_all_group"></div>
                <h2>업데이트를 준비중에 있습니다.</h2>
                <p>
                  해당 작품이 방송전이거나 아직 VOD가 업데이트 되지 않았습니다.{' '}
                </p>
                <span></span>
                <div className="episode_a"></div>
              </div>
            )}
            {/*
                        <div className="episode_list">
                            <div className="episode_img"><img src="/img/detail_img/test_img3.png"/></div>
                            <div className="chek_all_group">
                                <input name="선택" id="checkbox_1_1" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_1"></label>
                            </div>
                            <h2>1화. 마녀란 무엇인가<span>2020.10.18방영</span></h2>
                            <p>영화 촬영을 <br/>영화 촬영을 </p>
                            <span>무료</span>
                            <div className="episode_a">
                                <a href="#"><img src="/img/detail_img/down_btn2.png"/></a>
                                <a href="#"><img src="/img/detail_img/play_btn2.png"/></a>
                            </div>
                        </div>
                        <div className="episode_list">
                            <div className="episode_img"><img src="/img/detail_img/test_img3.png"/></div>
                            <div className="chek_all_group">
                                <input name="선택" id="checkbox_1_2" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_2"></label>
                            </div>
                            <h2>1화. 마녀란 무엇인가<span>2020.10.18방영</span></h2>
                            <p>영화 촬영을 <br/>영화 촬영을 </p>
                            <span><em>감상 700원</em><em>다운 1,500원</em></span>
                            <div className="episode_a">
                                <div className="box_graph">그래프</div>
                                <a href="#"><img src="/img/detail_img/play_btn2.png"/></a>
                            </div>
                        </div>
                        <div className="episode_list">
                            <div className="episode_img"><img src="/img/detail_img/test_img3.png"/></div>
                            <div className="chek_all_group">
                                <input name="선택" id="checkbox_1_3" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_3"></label>
                            </div>
                            <h2>1화. 마녀란 무엇인가<span>2020.10.18방영</span></h2>
                            <p>영화 촬영을 <br/>영화 촬영을 </p>
                            <span><em>감상 700원</em><em>다운 1,500원</em></span>
                            <div className="episode_a">
                                <a href="#"><img src="/img/detail_img/chek_btn.png"/></a>
                                <a href="#"><img src="/img/detail_img/play_btn2.png"/></a>
                            </div>
                        </div>
                        <div className="episode_list">
                            <div className="episode_img"><img src="/img/detail_img/test_img3.png"/></div>
                            <div className="chek_all_group">
                                <input name="선택" id="checkbox_1_4" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_4"></label>
                            </div>
                            <h2>1화. 마녀란 무엇인가<span>2020.10.18방영</span></h2>
                            <p>영화 촬영을 <br/>영화 촬영을 </p>
                            <span><em>감상 700원</em><em>다운 1,500원</em></span>
                            <div className="episode_a">
                                <a href="#"><img src="/img/detail_img/down_btn3.png"/></a>
                                <a href="#"><img src="/img/detail_img/play_btn2.png"/></a>
                            </div>
                        </div>
                        <div className="episode_list episode_on">
                            <div className="episode_img"><img src="/img/detail_img/test_img3.png"/></div>
                            <div className="chek_all_group">
                                <input name="선택" id="checkbox_1_5" type="checkbox" value="" className="checkbox_img"/><label htmlFor="checkbox_1_5"></label>
                            </div>
                            <h2>1화. 마녀란 무엇인가<span>2020.10.18방영</span></h2>
                            <p>영화 촬영을 <br/>영화 촬영을 </p>
                            <span><em>감상 700원</em><em>다운 1,500원</em></span>
                            <div className="episode_a">
                                <a href="#"><img src="/img/detail_img/down_btn2_on.png"/></a>
                                <a href="#"><img src="/img/detail_img/play_btn2_on.png"/></a>
                            </div>
                        </div>
                        */}
          </div>
          {/*
                    <div className="page_no">
                        <span>이전</span>
                        <span className="on">1</span>
                        <span>2</span>
                        <span>3</span>
                        <span>4</span>
                        <span>5</span>
                        <span>6</span>
                        <span>7</span>
                        <span>8</span>
                        <span>9</span>
                        <span>10</span>
                        <span>다음</span>
                    </div>
                    */}
        </div>

        {/*
                <div>
                    { contentPartList ? this._renderItem() : null }      
                </div>
                */}
        <Modal
          open={modalShow}
          showCloseIcon={false}
          onClose={this._onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
          styles={{ modal: { backgroundColor: 'black' } }}
        >
          <UsePoint
            contentSerial={contentSerial}
            //contentPartSerial={contentPartSerial}
            subPartSerial2={payCode}
            //subPartSerial3={subPartSerial3}
            payGubun={payGubun}
            chksale="ppv"
            onPointUse={this._setPointUse}
            onClose={this._onCloseModal}
            _selectedDown={this._selectedDown}
            _allDownCheck={this._allDownCheck}
          />
        </Modal>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ItemPart));
